
export const DEFAULT_LOCALE ='en';

export const LANGUAGES = [
    { code: 'en' , name: 'English',language : 'en-EN',flag: 'https://flagcdn.com/w40/gb.png' },
    { code: 'it' , name: 'Italiano',language : 'it-IT', flag: 'https://flagcdn.com/w40/it.png' },
    { code: 'fr' , name: 'Français',language : 'de-DE', flag: 'https://flagcdn.com/w40/fr.png' },
    { code: 'de' , name: 'Deutsch',language : 'de-DE', flag: 'https://flagcdn.com/w40/de.png' }
];

export const SUPPORTED_LANGUAGE = ['en', 'it','fr', 'de'] ;